import { User } from "model/user";
import { getUserObservable } from "services/authUtil";
import { Observable } from "utils/observable";
import { useEffect, useState } from "react";

// This hook updates whenever user in local storage updates.
export default function useUser(required?: false): User | undefined;
export default function useUser(required?: true): User;
export default function useUser(required: boolean = false): User | undefined {
  const userObservable: Observable<User> = getUserObservable();
  const [user, setUser] = useState(userObservable.getValue());

  useEffect(() => {
    userObservable.subscribe(setUser);
    return () => userObservable.unsubscribe(setUser);
  }, [userObservable]);

  if (required && !user) {
    throw new Error("Required user data is not available.");
  }

  return user;
}
